module.exports = __webpack_public_path__ + "img/success1.40a7205b.png";